/**
 * @author wangjunfeng
 */

export const site = state => state.site
